import {Button, IconButton} from "@zendeskgarden/react-buttons";
import {Tooltip} from "@zendeskgarden/react-tooltips";
import {ReactComponent as ChevronDownIcon} from "@zendeskgarden/svg-icons/src/12/chevron-down-stroke.svg";
import {ReactComponent as ChevronUpIcon} from "@zendeskgarden/svg-icons/src/12/chevron-up-stroke.svg";
import {ReactComponent as PencilIcon} from "@zendeskgarden/svg-icons/src/16/pencil-stroke.svg";
import {ReactComponent as TrashIcon} from "@zendeskgarden/svg-icons/src/16/trash-stroke.svg";
import cn from "classnames";
import {ReactElement} from "react";
import {NarrativeSection} from "../logic/useExecutiveSummaryNarrative";
import * as css from "../styles/narrativeEditor.module.scss";


interface NarrativeSectionRowProps {
    section: NarrativeSection;
    isFirst: boolean;
    isLast: boolean;
    isMuted: boolean;
    onMoveUp: () => void;
    onMoveDown: () => void;
    onEdit: () => void;
    onRemove: () => void;
}

export default function NarrativeSectionRow(props: NarrativeSectionRowProps): ReactElement {
    return (
        <div className={cn(css.sectionRow, props.isMuted && css.sectionRowMuted)}>
            <div className={css.sectionTitle}>{props.section.title}</div>
            <div className={css.sectionBody}>{props.section.body}</div>

            {!props.isMuted &&
                <div className={css.toolbar}>
                    <Tooltip size="small" content="Move up" type="light" zIndex={100}>
                        <IconButton
                            size="small"
                            aria-label="Move up"
                            disabled={props.isFirst}
                            onClick={props.onMoveUp}
                        >
                            <ChevronUpIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip size="small" content="Move down" type="light" zIndex={100}>
                        <IconButton
                            size="small"
                            aria-label="Move down"
                            disabled={props.isLast}
                            onClick={props.onMoveDown}
                        >
                            <ChevronDownIcon />
                        </IconButton>
                    </Tooltip>

                    <div className={css.toolbarDivider} />

                    <Button isBasic size="small" onClick={props.onEdit}>
                        <Button.StartIcon><PencilIcon /></Button.StartIcon>
                        Edit
                    </Button>

                    <div className={css.toolbarDivider} />

                    <Button isBasic isDanger size="small" onClick={props.onRemove}>
                        <Button.StartIcon><TrashIcon /></Button.StartIcon>
                        Remove
                    </Button>
                </div>
            }
        </div>
    );
}
